export const REQUEST = 'OPTIMALLES/REQUEST';
export const RECEIVE= 'OPTIMALLES/RECEIVE';
export const RECEIVE_PROMOTED= 'OPTIMALLES/RECEIVE_PROMOTED';
export const UPDATE_FILTERS = 'OPTIMALLES/UPDATE_FILTERS';